import React from 'react'
import { TextArea } from '../../Components'

const CommentView = ({ comment }) => {
  if (comment == null) {throw new Error('missing comment')}
  return <TextArea label="Commentaire" value={comment} readOnly={true} />
}

export default CommentView
